import { render, staticRenderFns } from "./AssignmentFilterToggle.vue?vue&type=template&id=5be47262"
import script from "./AssignmentFilterToggle.vue?vue&type=script&lang=ts"
export * from "./AssignmentFilterToggle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports